<app-panel-header-image-view pretitle="{{'Statistics' | transloco}}" title="{{'Longinesprizeforprecision' | transloco}}" banner_image="../../../modules/custom/wa_angular/app/assets/images/longines-banner.jpg"></app-panel-header-image-view>
<app-app-content-page-wrapper>
  <app-price-for-precision-filters></app-price-for-precision-filters>
  <app-price-for-precision-list></app-price-for-precision-list>
  <app-price-for-precision-panel></app-price-for-precision-panel>
</app-app-content-page-wrapper>
